import React from "react";
import "./ProgramCard.css"; // Import the custom CSS file

const ProgramCard = ({
    image,
    title,
    staff,
    gym_brand_id,
    brand_name,
    gym_location_id,
    requested_timezone_id,
    category,
    service_id,
    cal_date,
    service,
    idKey,
    serviceSubCategory,
    requestedServiceCategory,
    guestCheckoutUrl
}) => {

    const url = `https://${guestCheckoutUrl}.getphysio.biz/landing/landing-layout/guest-checkout?gym_brand_id=${gym_brand_id}&brand_name=${encodeURIComponent(
        brand_name
    )}&gym_location_id=${gym_location_id}&requested_timezone_id=${requested_timezone_id}&gym_service_category_id=${category}&gym_service_id=${service_id
        }&cal_date=${cal_date}&domain=${encodeURIComponent(
            "http://grace2fitness.getphysio.biz/service-calendar/"
        )}`;

    const handleRedirect = () => {
        window.location.href = url; // Redirect when clicking on the card
    };

    const firstPricing = service?.pricing?.length > 0 ? service.pricing[0] : null;
    const services = service?.services;

    return (
        <div className="card program-card" onClick={handleRedirect} style={{ cursor: "pointer" }}>
            <div className="row no-gutter p-2">
                {/* Left Side - Image */}
                <div className="col-md-4">
                    <div className="list_image">
                        {
                            serviceSubCategory &&
                            <div className="list_image_topbar">
                                <p className="category-badge">{serviceSubCategory}</p>
                            </div>
                        }
                        <img alt="list-img" className="program-img" src={image} />
                    </div>
                </div>

                {/* Right Side - Details */}
                <div className="col-md-8">
                    <div className="us_bg_card">
                        {/* Title & Menu */}
                        <div className="d-flex row justify-content-between align-items-center">
                            <h4 className="program-title">{title}</h4>
                            <h6>Price: ${firstPricing && firstPricing.price}</h6>
                            <p>{firstPricing && firstPricing.no_of_visits} visits valid for {firstPricing && firstPricing.used_within} Days</p>
                        </div>
                        {staff && staff.length > 0 &&
                            staff.map((member) => (
                                <div key={member.gym_staff_id} className="staff-member">
                                    {
                                        member.gym_staff_image_url && 
                                        <img src={member.gym_staff_image_url} alt={member.gym_staff_name} />
                                    }                                    
                                    <span>{member.gym_staff_name}</span>
                                </div>
                            ))
                        }

                        <div className="pricing-info" >

                            {services && services.length > 0 && (
                                <div style={{ marginTop: 10 }}>
                                    <h6><strong>Connected Services</strong></h6>
                                    <table className="table table-bordered table-condensed table-sm text-left">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Staff Assigned</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {services.map((service, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        {requestedServiceCategory == 6
                                                            ? service.service_name
                                                            : service.gym_service?.service_name}
                                                    </td>
                                                    <td>
                                                        {service.gym_staff && service.gym_staff.length > 0 ? (
                                                            service.gym_staff.map((staff, idx) => (
                                                                <span key={idx}>{staff.gym_staff_name}{idx + 1 < service.gym_staff.length ? ', ' : ''}</span>
                                                            ))
                                                        ) : (
                                                            <span>No staff assigned</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row no-gutter align-items-center  mt-auto">
                <div className="col-md-12 d-flex" >
                    <div className="button">
                        <a className="" onClick={handleRedirect}>
                            Purchase
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProgramCard;
